const LabTestUpsellConfig = [{ span: 8, height: "133px", classes: "marginTop-56" }]

export default LabTestUpsellConfig
